var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-wrapper"},[_c('div',[_c('h3',[_vm._v("Manage Media Services")]),_c('div',{staticClass:"col"},[_c('ListDeletedFolders')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }